import { config } from './config';

const baseBackendURL = config.url.baseBackendURL;
const baseAPIURL = config.url.baseAPIURL;

export {
    baseBackendURL,
    baseAPIURL,
}